module.exports = __webpack_public_path__ + "img/sq5m_05.f67692ac.jpg";